import { render, staticRenderFns } from "./WorkflowDetails.view.vue?vue&type=template&id=6ae1140a&scoped=true"
import script from "./WorkflowDetails.view.vue?vue&type=script&lang=js"
export * from "./WorkflowDetails.view.vue?vue&type=script&lang=js"
import style0 from "./WorkflowDetails.view.vue?vue&type=style&index=0&id=6ae1140a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae1140a",
  null
  
)

export default component.exports